import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import type { PendingVenue } from "./types";

export const PENDING_VENUES_QUERY_KEY = ["admin", "venues", "pending"] as const;

/**
 * CONTRACT: as of the current OpenAPI spec, `GET /api/admin/venues/pending`
 * returns a flat `VenueModel[]`. If API-1.2 lands and wraps it in an
 * envelope `{ items, totalCount }`, this function must be updated to
 * extract `.items`. The type assertion below will NOT catch this at
 * compile time — a runtime parse (Zod) or Orval-generated client would.
 * Accepted trade-off for Phase 1; revisit when the API pagination ships.
 */
async function fetchPendingVenues(): Promise<readonly PendingVenue[]> {
  return httpClient<PendingVenue[]>("/api/admin/venues/pending");
}

export function usePendingVenues() {
  return useQuery({
    queryKey: PENDING_VENUES_QUERY_KEY,
    queryFn: fetchPendingVenues,
    staleTime: 30_000,
  });
}
